import { keys, mustNeverExist } from "@repo/utils";
import type { PurchaseOrderWorkflowFields } from "../../types.js";
import * as aswoDeliveryState from "./aswoDeliveryState.js";
import type {
    ArbitraryFieldAdjustmentContext,
    ArbitraryFieldComparisonContext,
    ArbitraryFieldProcessingContext,
} from "./types.js";

export function handleArbitraryProcessing(fields: PurchaseOrderWorkflowFields, ctx: ArbitraryFieldProcessingContext) {
    for (const field of keys(fields)) {
        switch (field) {
            case "aswoDeliveryState":
                aswoDeliveryState.processing(ctx);
                break;
            case "reference":
            case "deliveryAddress":
            case "paymentTerms":
            case "deliveryTerms":
            case "extraItems":
            case "poNumber":
                break;
            default:
                throw mustNeverExist(field);
        }
    }
}

export function handleArbitraryComparison(fields: PurchaseOrderWorkflowFields, ctx: ArbitraryFieldComparisonContext) {
    for (const field of keys(fields)) {
        switch (field) {
            case "aswoDeliveryState":
                aswoDeliveryState.comparison(ctx);
                break;
            case "reference":
            case "deliveryAddress":
            case "paymentTerms":
            case "deliveryTerms":
            case "extraItems":
            case "poNumber":
                break;
            default:
                throw mustNeverExist(field);
        }
    }
}

export function handleArbitraryAdjustment(fields: PurchaseOrderWorkflowFields, ctx: ArbitraryFieldAdjustmentContext) {
    for (const field of keys(fields)) {
        switch (field) {
            case "aswoDeliveryState":
                aswoDeliveryState.adjust(ctx);
                break;
            case "reference":
            case "deliveryAddress":
            case "paymentTerms":
            case "deliveryTerms":
            case "extraItems":
            case "poNumber":
                break;
            default:
                throw mustNeverExist(field);
        }
    }
}
